import EStyleSheet from "react-native-extended-stylesheet";

export const styles = EStyleSheet.create({
  container: {
    padding: 0,
    justifyContent: "space-between",
  },
  playIcon: {
    backgroundColor: "$media_button_bg",
    padding: 10,
    zIndex: 1,
  },
  audioWave: {
    backgroundColor: "$input_background",
  },
  audioWaveImage: {
    width: 160,
    height: 46,
    tintColor: "#35ee5c",
  },
  removeIcon: {
    backgroundColor: "$media_button_bg",
    padding: 10,
  },
});
